var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iw-input-text',{attrs:{"input-label":_vm.$t('gsm_number'),"name":"gsmNumber","input-value":_vm.gsmNumber,"id":"gsmNumber","specific-id":_vm.specificId,"error-message":_vm.errorMessage},on:{"input":_vm.updateText}})}
var staticRenderFns = []

export { render, staticRenderFns }